export var VERSION = '2.11.11';
//# sourceMappingURL=version.js.map